import React from "react";
import { cn } from "@/lib/utils";
import { Inbox } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * EmptyState pattern from the design system §2.9:
 *   icon (40px, neutral-400) + H3 headline + body + optional primary action.
 */
export function EmptyState({
  icon: Icon = Inbox,
  title = "Nothing here yet",
  description,
  action,
  onAction,
  className,
}) {
  return (
    <div className={cn("flex flex-col items-center justify-center py-16 px-6 text-center", className)}>
      <Icon className="size-10 text-ink-hint mb-4" strokeWidth={1.6} />
      <h3 className="text-h3 text-ink font-semibold mb-1.5">{title}</h3>
      {description && (
        <p className="text-body text-ink-muted max-w-md mx-auto leading-relaxed">{description}</p>
      )}
      {action && (
        <Button onClick={onAction} className="mt-5 bg-brand-700 hover:bg-brand-800 text-white">
          {action}
        </Button>
      )}
    </div>
  );
}

export default EmptyState;
